export const hostnames = [
  'anvil.localhost',
  'bluestake.vercel.app',
  'cut-v2.mattlovan.dev',
  'daimo.ngrok.app',
  'localhost',
  'pay.daimo.com',
  'porto.sh',
  'relay.link',
  'uniswap.org',
]
